var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75487 10.8315C3.90792 13.3639 5.59146 18.3392 11.1012 17.9817C16.611 17.6242 17.9884 13.3639 17.9884 11.2784C18.1414 9.19294 16.8301 4.12821 11.1012 4.12821C5.37233 4.12821 1 4.12821 1 4.12821M1 4.12821L4.21402 1M1 4.12821L4.21402 7.25642",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReset);
export default __webpack_public_path__ + "static/media/icon-reset.3f536f844554782d2517f58808037270.svg";
export { ForwardRef as ReactComponent };